import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const ComponentWrapper = styled.div``;

const Label = styled.div`
  font-size: 14px;
  font-weight: 500;
  padding-bottom: 4px;
  color: ${({ theme }): string => theme.colors.black};
`;

const InputBox = styled.input<{ hasError: boolean }>`
  height: 34px;
  width: 100%;
  border-radius: 2px;
  padding-top: 0px;
  padding-bottom: 0px;
  border: solid 1px
    ${({ hasError, theme }): string =>
      hasError ? theme.colors.red : theme.colors.black10Alpha};
  background-color: ${({ theme }): string => theme.colors.white};
  font-size: 14px;
  color: ${({ theme }): string => theme.colors.black80Alpha};
  ::placeholder {
    color: ${({ theme }): string => theme.colors.black30Alpha};
  }
  padding-left: 8px;
  &:hover {
    border: solid 1px
      ${({ hasError, theme }): string =>
        hasError ? theme.colors.red : theme.colors.brandBlue20Alpha};
  }
  &:focus {
    outline: none;
    border: solid 1px
      ${({ hasError, theme }): string =>
        hasError ? theme.colors.red : theme.colors.brandBlue};
  }
`;

const ErrorMessage = styled.div`
  color: ${({ theme }): string => theme.colors.red};
  font-size: 12px;
`;

export interface InputProps extends React.HTMLProps<HTMLInputElement> {
  hasError?: boolean;
  errorMessage?: string;
  label?: string;
  value?: string;
}

export const Input = ({
  hasError = false,
  errorMessage,
  onChange,
  onBlur,
  onFocus,
  placeholder,
  label,
  value: initialValue = '',
}: InputProps): JSX.Element => {
  const [value, setValue] = useState<string>(initialValue);
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);
  return (
    <ComponentWrapper>
      {label && <Label data-testid="Label">{label}</Label>}
      <InputBox
        hasError={hasError}
        placeholder={placeholder}
        onChange={(event) => {
          setValue(event.target.value);
          if (onChange) {
            onChange(event);
          }
        }}
        onBlur={onBlur}
        onFocus={onFocus}
        data-testid="InputBox"
        value={value}
      />
      {errorMessage && (
        <ErrorMessage data-testid="ErrorMessage">{errorMessage}</ErrorMessage>
      )}
    </ComponentWrapper>
  );
};

export default Input;
